import type { TFunction } from 'i18next';
import { ApiError } from '../api/client';

export function apiErrorCode(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null;
  const detail = (err.body as { detail?: unknown } | null)?.detail;
  return typeof detail === 'string' ? detail : null;
}

/** Localized message for an auth API failure; unknown codes fall back to a generic text. */
export function authErrorMessage(t: TFunction, err: unknown, fallbackCode?: string): string {
  if (!(err instanceof ApiError)) return t('errors:network');
  const code = apiErrorCode(err);
  if (code && /^[a-z_]+$/.test(code)) {
    const message = t(`auth:errors.${code}`, { defaultValue: '' });
    if (message) return message;
  }
  if (err.status === 429) return t('auth:errors.too_many_requests');
  if (fallbackCode) return t(`auth:errors.${fallbackCode}`);
  return t('errors:generic');
}
